import ContactDto from 'common/dto-types/contacts/contact-dto';
import { ContactFormFields, defaultInitialContactFormValue } from './dto';
import { mapContactCategoryToSelectOption } from 'common/dto-types/contacts/contact-category-dto';

export const getContactFormInitialValues = (contact?: ContactDto): ContactFormFields =>
    !contact
        ? defaultInitialContactFormValue
        : {
              ...contact,
              address: {
                  value: contact.address?.id ?? 0,
                  label: `${contact.address?.name} - ${contact.address?.address ?? contact.address?.addressLine ?? ''}`,
              },
              contactType: {
                  value: contact.contactType?.id ?? 0,
                  label: contact.contactType?.name ?? '',
              },
              jobTitle: {
                  value: contact.jobTitle?.id ?? 0,
                  label: contact.jobTitle?.name ?? '',
              },
              categories: contact.categories ? mapContactCategoryToSelectOption(contact.categories) : [],
          };

export const convertContactFormFieldValuesToDto = (values: ContactFormFields) => ({
    ...values,
    address: {
        id: Number(values.address?.value) || 0,
    },
    contactType: {
        id: Number(values.contactType?.value) || 0,
    },
    jobTitle: {
        id: Number(values.jobTitle?.value) || 0,
    },
    categories:
        values.categories?.map((category) => ({
            id: typeof category.value === 'string' ? Number(category.value) ?? 0 : category.value,
            name: category.label,
            isFilterable: true,
        })) ?? [],
});
